module.exports = __webpack_public_path__ + "img/password.545dafb8.svg";